import React from "react";

import AboutADMKSection from "../Components/leaders/AboutADMKSection";
import AboutPolicySection from "../Components/leaders/AboutPolicySection";
import AboutPrLeaders from "../Components/leaders/AboutPrLeaders";
import CMaboutleaders from "../Components/leaders/CMaboutleaders";
import HistorySection from "../Components/leaders/HistorySection";
import LeadersSection from "../Components/leaders/LeadersSection";
import ContactSection from "../Components/ContactSection";

export default function RegistrationPage() {
  return (
    <>
      <LeadersSection />
      <AboutADMKSection />
      <HistorySection />
      <CMaboutleaders />
      <AboutPrLeaders />
      <AboutPolicySection />
      <ContactSection />
    </>
  );
}
